import { render, staticRenderFns } from "./StoreCarousel.vue?vue&type=template&id=706f80cd&"
import script from "./StoreCarousel.vue?vue&type=script&lang=js&"
export * from "./StoreCarousel.vue?vue&type=script&lang=js&"
import style0 from "./StoreCarousel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports